$(document).ready(function () { 
    const disabledDialColours = {
        "Model-1-Enamel":["Dial-Plum", "Dial-Blue", "Dial-Green", "Dial-Paynes-Grey", "Dial-Salmon", "Dial-Off-White", "Dial-GMT", "Dial-Racing-Green", "Dial-Flax", "Dial-White", "Dial-Aqua", "Dial-Lichen", "Dial-Black"],

        "Model-1-Fume": ["Dial-Oxblood", "Dial-Parisian Blue", "Dial-Iron Cream", "Dial-Teal", "Dial-Salmon", "Dial-Off-White", "Dial-GMT", "Dial-Racing-Green", "Dial-Flax", "Dial-White", "Dial-Aqua", "Dial-Lichen", "Dial-Black"],

        "Model-1-Fabrik":["Dial-Oxblood", "Dial-Parisian Blue", "Dial-Iron Cream", "Dial-Teal", "Dial-Plum", "Dial-Green", "Dial-Paynes-Grey", "Dial-Racing-Green", "Dial-Flax", "Dial-White", "Dial-Aqua", "Dial-Lichen", "Dial-Black"],

        "Model-2":["Dial-Oxblood", "Dial-Parisian Blue", "Dial-Iron Cream", "Dial-Teal", "Dial-Plum", "Dial-Blue", "Dial-Green", "Dial-Paynes-Grey", "Dial-Salmon", "Dial-Off-White", "Dial-GMT", "Dial-Aqua", "Dial-Lichen", "Dial-Black"],

        "Model-2-Porcelain":["Dial-Oxblood", "Dial-Parisian Blue", "Dial-Iron Cream", "Dial-Teal", "Dial-Plum", "Dial-Blue", "Dial-Green", "Dial-Paynes-Grey", "Dial-Salmon", "Dial-Off-White", "Dial-GMT", "Dial-Racing-Green", "Dial-Flax", "Dial-White", "Dial-Aqua", "Dial-Lichen"],

        "Model-3":["Dial-Oxblood", "Dial-Parisian Blue", "Dial-Iron Cream", "Dial-Teal", "Dial-Plum", "Dial-Blue", "Dial-Green", "Dial-Paynes-Grey", "Dial-Salmon", "Dial-Off-White", "Dial-GMT", "Dial-Racing-Green", "Dial-Flax", "Dial-White", "Dial-Black"]
    };

    function shouldDisableDialColour(model, dialColour) {
        var disabledDials = disabledDialColours[model];
        if (disabledDials) {
            return disabledDials.includes(dialColour);
        }
        return false; // Default case, not disabled
    }

    $("#model").on('change load', function (e) {
        var x = $("#model").val();
        $("#dial-colour").prop("disabled", x === "0" || x === null);
        $("#dial-colour option").each(function () {
            $(this).prop("disabled", shouldDisableDialColour(x, $(this).val()));
        });
        if (e && e.type === 'change') {
            validateRelatedSelects("#model", ["#dial-colour"]);
        }
        $("#dial-colour").selectric('refresh');
    }).trigger('load');


    const disabledLeathersStraps = {
        "bourbon": ["Horween Horsehide", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "cognac": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "intense": ["Horween Horsehide", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "green": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "deep": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "tan": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "dbrown": ["Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "liquorice": ["Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "navy": ["Horween Horsehide", "Horween-Shell", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "brown": ["Horween Horsehide", "Horween-Shell", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "honey": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "yew": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "coral": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "black": ["Horween Horsehide", "Horween Bison", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "teal":["Horween Horsehide", "Horween Bison","French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "foreesta": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "blue": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "burgundy": [ "Horween Bison", "French Chevre", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "biscuit": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "ortensia": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Nofin"],
        "mosto": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax"],
        "petrol": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax"],
        "napoli": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax"],
        "dnavy": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "unlined": ["Horween-Shell","Horween Bison", "French Chevre", "Walpier Buttero","Badalassi Carlo Wax"],
        "painted": ["1", "French Chevre", "Badalassi Carlo Nofin"],
        "gold-foil": ["Horween Horsehide", "Horween Bison"]
    };
   
    function shouldDisableLeatherColor(leatherType, colorId) {
        var disabledLeathers = disabledLeathersStraps[colorId];
        if (disabledLeathers) {
            return disabledLeathers.includes(leatherType);
        }
        return false; // Default case, not disabled
    }

    const disableFor = {
       "bourbon-keeper": ["Horween Horsehide", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "cognac-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "intense-keeper": ["Horween Horsehide", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "green-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "deep-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "tan-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "dbrown-keeper": ["Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "liquorice-keeper": ["Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "navy-keeper": ["Horween Horsehide", "Horween-Shell", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "brown-keeper": ["Horween Horsehide", "Horween-Shell", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "honey-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "yew-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "coral-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "black-keeper": ["Horween Horsehide", "Horween Bison", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "teal-keeper":["Horween Horsehide", "Horween Bison","French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "foreesta-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "blue-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "burgundy-keeper": [ "Horween Bison", "French Chevre", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "biscuit-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "ortensia-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Nofin"],
        "mosto-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax"],
        "petrol-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax"],
        "napoli-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax"],
        "dnavy-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"]
    };
    function shouldDisableKeeperColor(keeperLeather, colorId) {
        var disabledLeathers = disableFor[colorId];
        if (disabledLeathers) {
            return disabledLeathers.includes(keeperLeather);
        }
        return false; // Default case, not disabled
    }
    
    const disableForFloating = {
        "floating-bourbon-keeper": ["Horween Horsehide", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "floating-cognac-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "floating-intense-keeper": ["Horween Horsehide", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "floating-green-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "floating-deep-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "floating-tan-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "floating-dbrown-keeper": ["Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "floating-liquorice-keeper": ["Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "floating-navy-keeper": ["Horween Horsehide", "Horween-Shell", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "floating-brown-keeper": ["Horween Horsehide", "Horween-Shell", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "floating-honey-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "floating-yew-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "floating-coral-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "floating-black-keeper": ["Horween Horsehide", "Horween Bison", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "floating-teal-keeper":["Horween Horsehide", "Horween Bison","French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "floating-foreesta-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "floating-blue-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "floating-burgundy-keeper": [ "Horween Bison", "French Chevre", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "floating-biscuit-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"],
        "floating-ortensia-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Nofin"],
        "floating-mosto-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax"],
        "floating-petrol-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax"],
        "floating-napoli-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax"],
        "floating-dnavy-keeper": ["Horween Horsehide", "Horween-Shell", "Horween Bison", "French Chevre", "Walpier Buttero", "Badalassi Carlo Wax", "Badalassi Carlo Nofin"]
    };
    function shouldDisableFloatingKeeperColor(floatingKeeperLeather, colorId) {
        var disabledLeathers = disableForFloating[colorId];
        if (disabledLeathers) {
            return disabledLeathers.includes(floatingKeeperLeather);
        }
        return false; // Default case, not disabled
    }
    const disableStrapShape = {
        "Tapered": ["16mm"]
    };
    function shouldDisableStrapShape(strapWidth, strapShape) {
        var disabledStrapShape = disableStrapShape[strapShape];
        if (disabledStrapShape) {
            return disabledStrapShape.includes(strapWidth);
        }
        return false; // Default case, not disabled
    }
    // Function to validate related select inputs after a change
    function validateRelatedSelects(changedSelectId, relatedSelectIds) {
        relatedSelectIds.forEach(function(relatedSelectId) {
            var $relatedSelect = $(relatedSelectId);
            if ($relatedSelect.length > 0) {
                // Check if the entire select is disabled
                if ($relatedSelect.prop('disabled')) {
                    // Select is disabled, clear any current value
                    if ($relatedSelect.val() && $relatedSelect.val() !== "" && $relatedSelect.val() !== "0") {
                        $relatedSelect.val("").trigger('change');
                        $relatedSelect.selectric('refresh');
                    }
                } else {
                    // Select is enabled, check if current option is still available
                    var currentValue = $relatedSelect.find('option:selected').val();
                    // Only validate if there's a current value
                    if (currentValue && currentValue !== "" && currentValue !== "0" && currentValue !== null) {
                        // Find the currently selected option
                        var $currentOption = $relatedSelect.find('option:selected');
                        if ($currentOption.length > 0) {
                            // Check if the option is disabled
                            if ($currentOption.prop('disabled')) {
                                // Option is now disabled, clear the selection
                                $relatedSelect.val("").trigger('change');
                                $relatedSelect.selectric('refresh');
                            } else {
                                // Option is still enabled, keep it but refresh selectric
                                $relatedSelect.selectric('refresh');
                            }
                        }
                    }
                }
            }
        });
    }

    $("#strap-point").on('change load', function () {
        var x = $("#strap-point").val();
        $("#contactFormAngle").prop("disabled", x === "Curved" || x === "Pointed" || x === "0" || x === null);
    }).trigger('load');

    $("#stitch-pattern").on('change load', function () {
        var x = $("#stitch-pattern").val();
        $("#contactFormMessage").prop("disabled", x === "0" || x === "Linear" || x === "Wrapped" || x === null);
    }).trigger('load');

    $("#strap-style").on('change load', function (e) {
        var x = $("#strap-style").val();
        $("#line-colour").prop("disabled", x === "Single strip" || x === "Unlined" || x === "0" || x === null);
        $("#line-colour").selectric('refresh');
        $('#stitch-style option[value="Candy-cane-stitch"],#stitch-style option[value="Duotone-stitch"]').prop("disabled", x === "Unlined" || x === "0" || x === null);
        $('#stitch-style').selectric('refresh');
        
        // Validate related selects after disabling options (only on user change, not initial load)
        if (e && e.type === 'change') {
            validateRelatedSelects("#strap-style", ["#line-colour", "#stitch-style"]);
        }
    }).trigger('load');

    $("#strap-width").on('change load', function (e) {
        var x = $("#strap-width").val();
        $("#strap-shape option").each(function () {
            $(this).prop("disabled", shouldDisableStrapShape(x, $(this).attr("id")));
        });
        $("#strap-shape").selectric('refresh');
        if (e && e.type === 'change') {
            validateRelatedSelects("#strap-width", ["#strap-shape"]);
        }
     
        
        // var x = $("#strap-width").val();
        // $("#strap-shape").prop("disabled", x === "16mm" || x === "0" || x === null);
        // $("#strap-shape").selectric('refresh');
        
        // // Validate related selects after disabling options (only on user change, not initial load)
        // if (e && e.type === 'change') {
        //     validateRelatedSelects("#strap-width", ["#strap-shape"]);
        // }
    }).trigger('load');
  

    $("#edge-finish").on('change load', function (e) {
        var x = $("#edge-finish").val();
        $("#edge-colour").prop("disabled", x === "Sealed edges" || x === "0" || x === null);
        $("#edge-colour").selectric('refresh');
        
        // Validate related selects after disabling options (only on user change, not initial load)
        if (e && e.type === 'change') {
            validateRelatedSelects("#edge-finish", ["#edge-colour"]);
        }
    }).trigger('load');

    $("#stitch-style").on('change load', function (e) {
        var x = $("#stitch-style").val();
        $("#stitch-secondary-color").prop("disabled", x === "Saddle-stitch" || x === "0" || x === null);
        $("#stitch-secondary-color").selectric('refresh');
        
        // Validate related selects after disabling options (only on user change, not initial load)
        if (e && e.type === 'change') {
            validateRelatedSelects("#stitch-style", ["#stitch-secondary-color"]);
        }
    }).trigger('load');

    $("#debossing").on('change load',function () {
        var y = $("#debossing").val();
        $("#contactFormMessage2").prop("disabled", y === "0" || y === null);
        var thisParent = $(this).closest(".form__item");
        y === "0" || y === null ? thisParent.find(".text-area-variable").hide() : thisParent.find(".text-area-variable").show();
    }).trigger('load');

    $("#additional-comments").on('change load',function () {
        var y = $("#additional-comments").val();

        $("#contactFormMessage67").prop("disabled", y === "0" || y === null);
        var thisParent = $(this).closest(".form__item");
        y === "0" || y === null ? thisParent.find(".text-area-variable").hide() : thisParent.find(".text-area-variable").show();
    }).trigger('load');


    $("#leather-type").on('change load', function (e) {
        var x = $("#leather-type").val();
        $("#leather-colour option").each(function () {
            $(this).prop("disabled", shouldDisableLeatherColor(x, $(this).attr("id")));
        });
        $("#strap-style option").each(function () {
            $(this).prop("disabled", shouldDisableLeatherColor(x, $(this).attr("id")));
        });
        $("#debossing-type option").each(function () {
            $(this).prop("disabled", shouldDisableLeatherColor(x, $(this).attr("id")));
        });
        // $("#painted").prop("disabled", x === "1" || x === "Badalassi Carlo Nofin");
        $("#sealed").prop("disabled", x === "1" || x === "French Chevre");
        $('#leather-colour, #strap-style, #edge-finish, #debossing-type').selectric('refresh');
        
        // Validate related selects after disabling options (only on user change, not initial load)
        if (e && e.type === 'change') {
            validateRelatedSelects("#leather-type", ["#leather-colour", "#strap-style", "#debossing-type"]);
        }
    }).trigger('load');


    $("#keepers").on('change load', function () {
        var x = $("#keepers").val();
        $("#keepers-colour, #keepers-leather").prop("disabled", x === "Same-as-strap" || x === null);
        $("#keepers-colour, #keepers-leather").selectric('refresh');
    }).trigger('load');


    $("#keepers-leather").on('change load', function (e) {
        var x = $("#keepers-leather").val();
        $("#bourbon-keeper, #cognac-keeper, #black-keeper, #intense-keeper, #green-keeper, #deep-keeper, #tan-keeper, #dbrown-keeper, #liquorice-keeper, #navy-keeper, #brown-keeper, #honey-keeper, #yew-keeper, #coral-keeper, #foreesta-keeper, #blue-keeper, #burgundy-keeper, #biscuit-keeper, #ortensia-keeper, #mosto-keeper, #petrol-keeper, #napoli-keeper, #teal-keeper, #dnavy-keeper").each(function () {
            if(x != null){
                $(this).prop("disabled", shouldDisableKeeperColor(x, $(this).attr("id")));
            }
        });
        $("#keepers-colour").selectric('refresh');
        
        // Validate related selects after disabling options (only on user change, not initial load)
        if (e && e.type === 'change') {
            validateRelatedSelects("#keepers-leather", ["#keepers-colour"]);
        }

    }).trigger('load');


    

    $("#floating-keepers").on('change load', function () {
        var x = $("#floating-keepers").val();
        $("#floating-keepers-colour, #floating-keepers-leather").prop("disabled", x === "Same-as-strap" || x === null);
        $("#floating-keepers-colour, #floating-keepers-leather").selectric('refresh');
    }).trigger('load');

    $("#floating-keepers-leather").on('change load', function (e) {
        var x = $("#floating-keepers-leather").val();
        $("#floating-bourbon-keeper, #floating-cognac-keeper, #floating-black-keeper, #floating-intense-keeper, #floating-green-keeper, #floating-deep-keeper, #floating-tan-keeper, #floating-dbrown-keeper, #floating-liquorice-keeper, #floating-navy-keeper, #floating-brown-keeper, #floating-honey-keeper, #floating-yew-keeper, #floating-coral-keeper, #floating-foreesta-keeper, #floating-blue-keeper, #floating-burgundy-keeper, #floating-biscuit-keeper, #floating-ortensia-keeper, #floating-mosto-keeper, #floating-petrol-keeper, #floating-napoli-keeper, #floating-teal-keeper, #floating-dnavy-keeper").each(function () {
            $(this).prop("disabled", shouldDisableFloatingKeeperColor(x, $(this).attr("id")));
            
        });
        $("#floating-keepers-colour").selectric('refresh');
        
        // Validate related selects after disabling options (only on user change, not initial load)
        if (e && e.type === 'change') {
            validateRelatedSelects("#floating-keepers-leather", ["#floating-keepers-colour"]);
        }
    }).trigger('load');


    // $("#debossing").on('change load', function () {
    //     var x = $("#debossing").val();
    //     $("#debossing-text, #debossing-type, #debossing-position").prop("disabled", x === "0" || x === null);
    // }).trigger('load');


    function submitBtnValidation() {
        let missingFields = [];
        $("[required]").each(function () {
            if (!$(this).val() || $(this).val() === "0" || $(this).val() === null) {
                const fieldName = $(this).closest(".form__item").find('h3').html() || $(this).data('name');
                if (fieldName && !missingFields.includes(fieldName)) {
                    missingFields.push(fieldName);
                }
            }
        });
        if (missingFields.length > 0) {
            $('#mySizeChart').removeClass('btn-active');
        } else {
            $('#mySizeChart').addClass('btn-active');
        }
    }

    function checkRequiredFields() {
        let missingFields = [];
        $('.required-fields-error-msg').empty();
        $("[required]").each(function () {
            if (!$(this).val() || $(this).val() === "0" || $(this).val() === null) {
                const fieldName = $(this).closest(".form__item").find('h3').html() || $(this).data('name');
                if (fieldName && !missingFields.includes(fieldName)) {
                    missingFields.push(fieldName);
                }
            }
        });

        if (missingFields.length > 0) {
            
            for (let i = 0; i < missingFields.length; i++) {
                const fieldName = missingFields[i];
                $('.required-fields-error-msg').append('<p>*Missing answer: <em>' + fieldName + '</em></p>');
            }
        } else {
            $('#contact_form').submit();
        }
    }

    $('.new-form select, .new-form input, .new-form textarea').on('change',function(){
        submitBtnValidation();
    })
    $('#mySizeChart').on('click',function(e){
        e.preventDefault();
        checkRequiredFields();
    })
 
    if($(".info_target").length > 0){
        $(".info_trigger > a").on("click",function(e){
            e.preventDefault();
            $(this).toggleClass("active");
            item = $(this).data("item");
            $("#"+item).find(".info_target").slideToggle();
            // $("#"+item).find(".info_target").each(function() {
            //     $(this).slideToggle();
            // });
        })
    }
});
